import React, { useState } from "react";
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Button, Tooltip, CircularProgress } from "@mui/material";
import * as actions from '../../../reducers/materialLoad';
import { fetchDispath } from '../../../functions/fetch'
import { useHistory, } from 'react-router-dom'
import { okeiUpload } from '../../../api/list'
import { enqueueSnackbar } from '../../../reducers/notifier'

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  input: {
    display: 'none',
  },
  edt: {
    padding: '1px', /* Поля вокруг текста */
  },
  main: {
    margin: theme.spacing(1)
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 240,
    marginTop: 5,
    marginBottom: 3,
    width: '50%'
  },
}));
function fileNameShorter(fileName) {
  if (fileName.length > 38) {
    return fileName.slice(0, 17) + '...' + fileName.slice(-18)
  }
  else return fileName
}
export default function OkeiUpload() {
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [fileId, setFileId] = useState()
  const [file, setFile] = useState('')
  const [fileShort, setFileShort] = useState('')

  const handleUpload = (e) => {
    e.preventDefault();
    if (typeof e.target.files[0] === 'undefined' || e.target.files[0].length === 0) return
    setLoading(true)
    const fileName = e.target.files[0].name
    setFile(fileName)
    setFileShort(fileNameShorter(fileName))
    dispatch(actions.loadFileAPI({ file: e.target.files[0], path: `/files/add` }))
      .then(res => {
        if (res.success) {
          setFileId(res.id)
        }
        setLoading(false)
      })
  }
  const handleUpdate = () => {
    if (!fileId) return
    dispatch(fetchDispath({
      body: {
        idFile: fileId
      },
      progress: true,
      request: okeiUpload,
    })).then(res => {
      if (res.success) {
        dispatch(enqueueSnackbar({
          message: res.message,
          options: { variant: 'success' }
        }))
      }
      else {
        dispatch(enqueueSnackbar({
          message: res.message,
          options: { variant: 'error' }
        }))
      }
    })
  }
  return <div className="App-paper">
    <Typography variant='h6'>Выбор файла</Typography>
    <div className={classes.formControl}>
      <input
        className={classes.input}
        id="contained-button-file"
        type="file"
        accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={(e) => handleUpload(e)}
      />
      <label htmlFor="contained-button-file">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item >
            <Button variant='contained' component="span" size="small">Файл</Button>
          </Grid>
          <Grid item >
            <Tooltip title={file || ''}><Typography>{fileShort}</Typography></Tooltip>
          </Grid>
          <Grid item >
            {loading && <CircularProgress size={20} />}
          </Grid>
        </Grid>
      </label>
    </div>
    <Button onClick={() => history.goBack()}>Назад</Button>
    <Button onClick={handleUpdate} disabled={!fileId}>Обновить </Button>
    <Typography variant="h6"> Вид файла</Typography>
    <div style={{ fontSize: '12px', color: '#666' }}>
      * Строка 1: Заголовки (code, name, symbol_national, symbol_intl, code_letter_nat, code_letter_intl, section).<br />
      * Данные должны начинаться строго со 2-й строки.
    </div>
  </div>
}